import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const TabletFeatureView = ({
  inView,
  fadeInUp,
  featureIcons,
  featureTexts,
  images,
}) => {
  return (
    <div className="tf-feature-column d-flex flex-row">
      <motion.div
        className="tf-feature-first-column col-4"
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={fadeInUp}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <div className="tf-first-pic-div">
          <img
            className="tf-feature-first-pic"
            src={images.abbRobot}
            alt="ABB Robot"
          />
        </div>
        <div className="tf-second-pic-div">
          <img
            className="tf-feature-second-pic"
            src={images.pnc}
            alt="PNC System"
          />
          <h1
            className="tf-terafac-live"
            style={{ fontFamily: "Audiowide", fontWeight: 400 }}
          >
            TERAFAC
          </h1>
          <img
            className="tf-feature-third-pic"
            src={images.operator}
            alt="Operator"
          />
        </div>
      </motion.div>
      <div className="tf-feature-second-column col-8">
        {featureTexts.map((text, index) => (
          <motion.div
            key={index}
            className={`col-9 tf-features-div ${
              index % 2 === 1 ? "offset-2" : ""
            }`}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={fadeInUp}
            transition={{ duration: 1, delay: index * 0.2 }}
          >
            <div className="tf-icon-container white-icon">
              <Icon
                icon={featureIcons[index]}
                style={{
                  fontSize: "35px",
                  width: "30px",
                  height: "30px",
                  color: "white",
                }}
              />
            </div>
            <h2 style={{ marginLeft: 10, marginRight: 10 }}>{text}</h2>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TabletFeatureView;
